<template>
    <div id="events-page">
        <loader v-if="is('loading')"></loader>
        <div class="container-fluid" v-if="!is('loading')">
            <div class="row">
                <div class="col-md-12">
                    <div class="box">
                    <div class="clearfix">
                        <template v-if="pagination.total === 0 && !searchQuery && events.length === 0">
                            <h2>{{ t('customEvents-title') }}</h2>
                            <div class="clear"></div>
                            <span
                                class="alert alert-info"
                                style="margin-bottom: 10px; display: inline-block"
                            >
                                {{ t('customEvents-empty_message') }}
                                <strong> {{ t('customEvents-empty_action') }} </strong>
                            </span>
                            <button
                                class="btn btn-new btn-outline-success pull-right"
                                @click="addEvent"
                            >
                                {{ t('customEvents-new_event_button') }}
                            </button>
                        </template>

                        <template v-if="pagination.total > 0 || searchQuery || events.length > 0">
                            <h2>{{ t('customEvents-title') }}</h2>
                            <div class="clear"></div>
                            <div class="search-bar">
                                <input
                                    id="customEvents-search"
                                    name="search"
                                    type="text"
                                    class="form-control"
                                    :placeholder="t('customEvents-search_placeholder')"
                                    v-model="searchQuery"
                                />
                            </div>
                            <div v-if="searchQuery && events.length === 0 && !is('loading')" class="alert alert-info" style="margin-top: 15px;">
                                <span v-html="t('customEvents-no_results_found', [searchQuery])"></span>
                                <a href="#" @click.prevent="clearSearch" style="text-decoration: underline;">{{ t('customEvents-clear_search') }}</a>
                            </div>
                            <div class="events">
                                <event
                                    v-for="event in filteredEvents"
                                    ref="events"
                                    :key="event.id"
                                    :disabled="is('saving')"
                                    :id="event.id"
                                    :title="event.title"
                                    :used="event.used"
                                    :registrations="event.registrations"
                                ></event>
                            </div>
                            <kv-pagination
                                v-if="pagination.total > 0"
                                :total="pagination.total"
                                :current-page="pagination.page"
                                :items-per-page="pagination.limit"
                                :show-items-per-page="true"
                                @page-change="goToPage"
                                @items-per-page-change="updateItemsPerPage"
                            />
                            <div class="clear"></div>
                            <div class="save" v-if="events.length">
                                <span
                                    class="alert alert-success"
                                    v-if="showSuccess"
                                    >{{ t('customEvents-save_success') }}</span
                                >
                                <div class="clear"></div>
                                <button
                                    class="btn btn-new btn-outline-success pull-right"
                                    @click="addEvent"
                                >
                                    {{ t('customEvents-new_event_button') }}
                                </button>
                                <button
                                    class="btn pull-right btn-success"
                                    :disabled="is('saving')"
                                    @click="save"
                                >
                                    <span
                                        class="far fa-spin fa-spinner"
                                        v-if="is('saving')"
                                    ></span>
                                    {{ t('customEvents-save_button') }}
                                </button>
                            </div>
                        </template>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";
import event from "./event.vue";
import KvPagination from "../components/ui/kv-pagination.vue";

export default {
    name: "custom-events",
    components: {
        event: event,
        KvPagination
    },
    data: function () {
        return {
            events: [],
            textNewEvent: "",
            state: "loading",
            showSuccess: false,
            searchQuery: "",
            searchDebounceTimer: null,
            skipSearchWatch: false,
            pagination: {
                total: 0,
                page: 1,
                limit: 10,
                totalPages: 0,
                hasNext: false,
                hasPrev: false,
            },
        };
    },
    computed: {
        filteredEvents() {
            return this.events;
        },
    },
    created: function () {
        document.getElementsByTagName("title")[0].innerText =
            this.t('customEvents-page_title');
        this.updateList();
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        save: function () {
            this.state = "saving";
            window.mixpanel?.track("Custom Events - save begin");
            let bulkData = [];
            let removedEvents = [];
            for (let c in this.$refs.events) {
                let event = this.$refs.events[c];
                if (!event.removed) {
                    let eventData = event.getData();
                    eventData.id = event.id;
                    bulkData.push(eventData);
                } else {
                    removedEvents.push(event.id);
                }
            }
            var options = keviApi.getOptions("custom-event/bulk-save", "PUT", {
                events: bulkData,
                removedEvents: removedEvents,
            });
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.$store.dispatch(
                        "notification/success",
                        this.t("customEvents-save_success"),
                    );
                    if (response.body.data && response.body.pagination) {
                        this.events = response.body.data;
                        this.pagination = response.body.pagination;
                    }
                    window.mixpanel?.track("Custom Events - save success");
                    this.setState("list");
                }
            });
        },
        updateList: function () {
            this.setState("loading");
            const params = `?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${encodeURIComponent(this.searchQuery)}`;
            var options = keviApi.getOptions(`custom-event/events${params}`);
            this.$http(options).then(function (response) {
                if (response.status === 200) {
                    if (response.body.data && response.body.pagination) {
                        this.events = response.body.data;
                        this.pagination = response.body.pagination;
                    }
                    this.setState("list");
                } else {
                    this.setState("empty");
                }
            });
        },
        goToPage: function (page) {
            if (page >= 1 && page <= this.pagination.totalPages) {
                this.pagination.page = page;
                this.updateList();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        addEvent: function () {
            let newevent = {
                text: "",
                probability: 0,
                status: "new",
                used: 0,
                generated: 0,
            };
            this.events.push(newevent);
            window.mixpanel?.track("Custom Events - add");
            this.textNewEvent = "";
        },
        clearSearch: function () {
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }
            this.skipSearchWatch = true;
            this.searchQuery = "";
            this.pagination.page = 1;
            this.updateList();
            this.$nextTick(() => {
                this.skipSearchWatch = false;
            });
        },
        updateItemsPerPage: function (newLimit) {
            this.pagination.limit = newLimit;
            this.pagination.page = 1;
            this.updateList();
        },
    },
    watch: {
        events: function () {
            if (this.events.length) {
                this.setState("list");
            } else {
                this.setState("empty");
            }
        },
        searchQuery: function () {
            if (this.skipSearchWatch) {
                return;
            }

            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }
            this.searchDebounceTimer = setTimeout(() => {
                this.pagination.page = 1;
                this.updateList();
            }, 500);
        },
    },
};
</script>
